import { createBrowserRouter } from "react-router-dom";
import { Root } from "~/Root";
import { Home } from "~/routes/Home";
import { Play } from "~/routes/Play";
import { Augment } from "~/routes/Augment";
import { Mobile } from "~/routes/Mobile";
import { ReactNative } from "~/routes/ReactNative";
import { AI } from "~/routes/AI";
import { Trade } from "~/routes/Trade";
import { Build } from "~/routes/Build";
import { Engine } from "~/routes/Engine";
import { Hire } from "~/routes/Hire";
import { NotFound } from "~/routes/NotFound";
import { Tutorial } from "~/routes/Tutorial";
import { TutorialCabecudo } from "~/routes/TutorialCabecudo";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      { index: true, element: <Home /> },
      { path: "play", element: <Play /> },
      { path: "augment", element: <Augment /> },
      { path: "mobile", element: <Mobile /> },
      { path: "react-native", element: <ReactNative /> },
      { path: "ai", element: <AI /> },
      { path: "trade", element: <Trade /> },
      { path: "build", element: <Build /> },
      { path: "engine", element: <Engine /> },
      { path: "hire", element: <Hire /> },
      { path: "tutorial", element: <Tutorial /> },
      { path: "tutorial/cabecudo", element: <TutorialCabecudo /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
